import { render } from "./Q4DetailleeOptionB.vue?vue&type=template&id=4f84daf9"
import script from "./Q4DetailleeOptionB.vue?vue&type=script&lang=js"
export * from "./Q4DetailleeOptionB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__